import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../language/vn';
import {SoVanThuService} from '../../../service/info/service-sovanthu';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { Subject} from 'rxjs';
import {StaffsService} from '../../../service/staff/service-staffs';
import {ChucVu} from '../../../models/danhmuc/chucvu';
import {ChucVuService} from '../../../service/danhmuc/service-chucvu';
import {GroupOTherComponent} from '../groupother/groupother.component';
import {GroupInnerComponent} from '../groupother/groupinner.component';
import {SelectMultiComponent} from '../groupother/select.component';
import {Staffs} from '../../../models/staff/staffs';
import {StaffChucVuService} from '../../../service/staff/service-staffchucvu';
import {StaffDepartmentService} from '../../../service/staff/service-staffdepartment';
@Component({
  templateUrl: './pdf.component.html'

})export class PdfShowComponent implements OnInit {
  public language = language;
  public frmGroup: FormGroup;
  public id: number = 0;
  public isEdit: boolean = false;
  public isSuDung: boolean = true;
  public submitValidate = false;
  public onClose: Subject<boolean>;
  public pdfSrc: String;

  constructor(public bsModalService: BsModalService,
              public _bsModalRef: BsModalRef,
  ) {

  }
  ngOnInit(): void {
    this.onClose = new Subject();


  }

  public show(url: String)
  {
    this.pdfSrc= url;
  }

  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}
